export const UserLogin = {
	'Sign in': 'Inicio de Sesión',
	'Please type your username and password':
		'Por favor ingresa tu nombre de usuario y contraseña',
	Email: 'Correo electrónico',
	'DNI or Email': 'RUT (sin puntos y con guión) ó Correo electrónico',
	Password: 'Contraseña',
	'Forgot your password?': '¿Olvidaste tu contraseña?',
	Enter: 'Ingresar',
	'Stil not registered?': '¿Aún no estás registrado?',
	'Sign up here!': '¡Inscríbete aquí!',
	'Too many attempts': 'Demasiados intentos',
	'Too many login attempts, please wait a moment':
		'Demasiados intentos de inicio de sesión. Espera unos minutos e inténtalo nuevamente.',
};
